import { type ViewId, windowFor } from './liveDataAdapter';

/** Reset only this report's scope; retain the current sheet and shell URL state. */
export function resetProductScope(search: string, view: ViewId): string {
  const next = new URLSearchParams(search);
  const defaults = windowFor(view);
  ['pd_comparison', 'pd_vertical', 'pd_chain', 'pd_vendor'].forEach((key) => next.delete(key));
  next.set('pd_from', defaults.from);
  next.set('pd_to', defaults.to);
  return next.toString();
}
